var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        "padding-top": "20px",
        "padding-left": "20px",
        "background-color": "white"
      }
    },
    [
      _c(
        "el-button",
        {
          staticStyle: { width: "110px" },
          attrs: { type: "primary", no: "uploadFile" },
          on: {
            click: function($event) {
              return _vm.$refs.dropUploader.triggeFileSelectWindow()
            }
          }
        },
        [_vm._v(_vm._s(_vm.$t("SeaExport.UploadFile")))]
      ),
      _c("drop-uploader", {
        ref: "dropUploader",
        attrs: {
          action: _vm.URL.sys.ocrImportAndAnalyseFile,
          "upload-params": { ocrTemplateUuid: _vm.ocrTemplate.uuid },
          accept: [
            "pdf",
            "xls",
            "xlsx",
            "doc",
            "docx",
            "jpg",
            "gif",
            "png",
            "tif",
            "msword",
            "ms-excel",
            "jpeg",
            "rtf"
          ],
          "file-format": _vm.fileFormat,
          "close-on-click-modal": false,
          multiple: false
        },
        on: { "upload-result": _vm.uploadSuccessHandler }
      }),
      _c(
        "cargo-left-right-resize",
        {
          staticStyle: { width: "100%", height: "100%" },
          attrs: {
            "left-style": { "min-width": "550px", width: "33%" },
            "right-style": { "min-width": "110px", width: "66%" }
          }
        },
        [
          _c(
            "template",
            { slot: "left" },
            [
              _c(
                "el-form",
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_OcrCode") } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled: !_vm.ocrTemplate.code
                          },
                          on: { click: _vm.runCode }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Run")))]
                      ),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: _vm.$t("Message.CodeTip"),
                            placement: "right"
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-warning",
                            staticStyle: {
                              color: "#E6A23C",
                              padding: "0 5px",
                              "font-size": "18px",
                              "margin-left": "10px"
                            }
                          })
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        staticStyle: {
                          width: "100%",
                          height: "670px",
                          "margin-top": "5px"
                        },
                        attrs: {
                          "filter-chars": false,
                          no: "1",
                          type: "textarea",
                          rows: 37
                        },
                        model: {
                          value: _vm.ocrTemplate.code,
                          callback: function($$v) {
                            _vm.$set(_vm.ocrTemplate, "code", $$v)
                          },
                          expression: "ocrTemplate.code"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "template",
            { slot: "right" },
            [
              _c(
                "cargo-left-right-resize",
                {
                  staticStyle: { width: "100%", height: "100%" },
                  attrs: {
                    "left-style": { "min-width": "550px", width: "50%" },
                    "right-style": { "min-width": "550px", width: "50%" }
                  }
                },
                [
                  _c(
                    "template",
                    { slot: "left" },
                    [
                      _c(
                        "el-form",
                        { attrs: { "label-position": "top" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_originalValue")
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    height: "669px",
                                    border: "1px solid #cccccc"
                                  }
                                },
                                [
                                  _vm.ocrTemplate.originResultJson
                                    ? _c("json-viewer", {
                                        staticStyle: {
                                          "white-space": "nowrap",
                                          "font-size": "small",
                                          height: "667px",
                                          "font-family": "'Courier New'",
                                          "vertical-align": "top",
                                          "overflow-y": "auto"
                                        },
                                        attrs: {
                                          value: JSON.parse(
                                            _vm.ocrTemplate.originResultJson
                                          ),
                                          sort: "",
                                          "expand-depth": 6
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "template",
                    { slot: "right" },
                    [
                      _c(
                        "el-form",
                        { attrs: { "label-position": "top" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_DebuggingResults")
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    height: "669px",
                                    border: "1px solid #cccccc"
                                  }
                                },
                                [
                                  _vm.ocrTemplate.resultJson
                                    ? _c("json-viewer", {
                                        staticStyle: {
                                          "white-space": "nowrap",
                                          "font-size": "small",
                                          height: "667px",
                                          "font-family": "'Courier New'",
                                          "vertical-align": "top",
                                          "overflow-y": "auto"
                                        },
                                        attrs: {
                                          value: JSON.parse(
                                            _vm.ocrTemplate.resultJson
                                          ),
                                          sort: "",
                                          "expand-depth": 6
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        2
      ),
      _c(
        "div",
        {
          staticStyle: { display: "flex", "justify-content": "center" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "4" },
              on: { click: _vm.saveOcrTemplate }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
          ),
          _c(
            "el-button",
            {
              staticStyle: { "margin-left": "5px" },
              attrs: { type: "primary", no: "5" },
              on: {
                click: function($event) {
                  return _vm.goBack()
                }
              }
            },
            [_vm._v(" " + _vm._s(_vm.$t("CargoMsg.Cargo_Back")) + " ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }